module.exports = __webpack_public_path__ + "src/client/components/LandingPage/img/icon-w2.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/components/LandingPage/img/icon-w2.png
// module id = 1214
// module chunks = 0